import React from 'react';
import { StatusStyle } from '../Status/StatusDot';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';

export const waterServiceStatusStyle = (testStatus?: string): StatusStyle => {
  switch (testStatus) {
    case 'ACTIVE':
      return 'success';
    case 'INACTIVE':
      return 'error';
    default:
      return 'default';
  }
};

export const lastTestResultStyle = (testResult?: string): StatusStyle => {
  switch (testResult) {
    case 'PASS':
      return 'success';
    case 'FAIL':
      return 'error';
    default:
      return 'default';
  }
};

export const waterServiceStatusFormat = (testStatus?: string): string =>
  constantToLabel(testStatus);
